export default __webpack_public_path__ + "static/media/promotion.ab700127.svg";